/**
 * @module estrutura/ui/estruturalabelui
 */

import { Plugin } from 'ckeditor5/src/core';
import { ButtonView } from 'ckeditor5/src/ui';
import estruturaLabelIcon from '../../theme/icons/estruturaLabel.svg';
import EstruturaLabelEditing from '../label/estruturalabelediting';

const ESTRUTURA_LABEL = 'estruturaLabel';

/**
 * The estrutura label UI feature.
 *
 * It introduces the `'estruturalabel'` button.
 *
 * @extends {Plugin}
 */
export default class EstruturaLabelUI extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'EstruturaLabelUI';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ EstruturaLabelEditing ];
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const t = editor.t;

		editor.ui.componentFactory.add( ESTRUTURA_LABEL, locale => {
			const command = editor.commands.get( ESTRUTURA_LABEL );
			const buttonView = new ButtonView( locale );

			buttonView.set( {
				label: "Adicionar tag",
				icon: estruturaLabelIcon,
				tooltip: true
			} );

			buttonView.bind( 'isOn', 'isEnabled' ).to( command, 'value', 'isEnabled' );
			this.listenTo( buttonView, 'execute', () => editor.execute( ESTRUTURA_LABEL ) );

			return buttonView;
		} );
	}
}
